import { useServiceTerms, useUserInformations } from '../../hooks/WPHooks';
import { useHousePages, useHouses } from '../../hooks/HouseHooks';

interface LoadDataOnceProps { }

const LoadDataOnce: React.FC<LoadDataOnceProps> = () => {

  // Globally fetch user when connected
  useUserInformations(true);

  // Globally fetch houses pages
  useHousePages(true);

  // Globally fetch houses
  useHouses(true);

  // Globally fetch services
  useServiceTerms(true);

  return <></>
};

export default LoadDataOnce;
